<!--
作者：Loong
时间：2020/11/10
-->
<!-- PropertyRecord [ 物业缴费记录 ] -->
<template>

    <div id='PropertyRecord' class="cash_list">
        <el-form :inline="true" :model="select" class="demo-form-inline" @keyup.enter.native="seach">
			<el-form-item label="状态">
				<el-select v-model="select.nature" placeholder="请选择" style="width: 150px;">
					<el-option v-for="item in natures" :key="item.num" :label="item.value" :value="item.num">
					</el-option>
				</el-select>
			</el-form-item>
			<el-form-item label="创建时间">
				<el-date-picker v-model="select.startTime" type="date" placeholder="选择开始日期">
				</el-date-picker>
				<el-date-picker v-model="select.endTime" type="date" placeholder="选择结束日期">
				</el-date-picker>
			</el-form-item>
				<el-button type="primary" @click="seachCashList">查询</el-button>
				<el-button type="primary" @click="returnSearch">重置</el-button>
				<el-button type="primary" @click="downLoadList">导出</el-button>
			</el-form-item>
		</el-form>
        <el-table :data="meterList" border style="width:1652px;text-align:center;margin-bottom: 10px;font-size:12px;margin-top: 10px;">
			<el-table-column prop="create_time" label="创建时间" align="center" >
			</el-table-column>
			<el-table-column prop="extract_cost" label="提现金额（元）"  align="center">
			</el-table-column>
			<el-table-column prop="status" label="状态"  align="center">
			</el-table-column>
			<el-table-column prop="remark" label="备注"  align="center">
			</el-table-column>
			<el-table-column prop="sumbit" align="center" label="附件">
				<template scope="scope" >
					<el-button  type="primary"  size="mini" @click="showAttachment(scope.row)" v-if="scope.row.attachment != ''">查看</el-button>
				</template>
			</el-table-column>
			<el-table-column prop="sumbit" align="center" label="操作">
				<template scope="scope">
					<el-button  type="primary"  size="mini" @click="removeCash(scope.row)" v-if="scope.row.status == '待审核'">撤回</el-button>
					<el-button  type="primary"  size="mini" @click="cashInfo(scope.row)">详情</el-button>
				</template>
			</el-table-column>
		</el-table>
		<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :page-size="pageSize" layout="total,prev, pager, next" :total="total">
		</el-pagination>
		<div class="showAttachment" v-if="showConcentImg">
			<div class="showImg" >
				<img src="../../assets/close_white.png"  style="position:absolute;right:30px;top:30px;width:40px;"@click="closeAttachment">
				<div class="before" @click="imgGoBefore" v-if="showBeforeImg">
					<img src="https://pro.minegou.cn/img_before.png">
				</div>
				<img :src="concent_img">
				<div class="after" @click="imgGoAfter" v-if="showAfterImg">
					<img src="https://pro.minegou.cn/img_after.png">
				</div>
			</div>
		</div>
		<div class="showAttachment" v-if="showCashInfo">
			<div class="cash_info">
				<ul>
					<li>
						<span>小区名称：</span><strong>{{community}}</strong>
					</li>
					<li>
						<span>申请人：</span><strong>{{member}}</strong>
					</li>
					<li>
						<span>账户名称：</span><strong>{{invoice_account_name}}</strong>
					</li>
					<li>
						<span>开户行名称：</span><strong>{{invoice_bank_name}}</strong>
					</li>
					<li>
						<span>银行账户：</span><strong>{{invoice_acount}}</strong>
					</li>
					<li>
						<span>提现金额（元）：</span><strong>{{extract_cost}}</strong>
					</li>
					<li>
						<span>申请前余额（元）：</span><strong>{{can_extract_cost}}</strong>
					</li>
					<li>
						<span>审批状态：</span><strong>{{status}}</strong>
					</li>
					<li>
						<span>创建时间：</span><strong>{{create_time}}</strong>
					</li>
					<li>
						<span>备注：</span><strong>{{remark}}</strong>
					</li>
					<li>
						<button type="primary" @click="closeCashInfo">关闭</button>
					</li>
				</ul>
			</div>
		</div>
    </div>

</template>

<script>
import { mapState, mapGetters } from 'vuex'
export default {
    components: { },

    props: [],

    data() {
        return{
            select:{
                startTime:'',
                endTime:'',
                nature:''
            },
            prop:'',
            order:'',
            pageSize:15,
            total:0,
            meterList:[],
            showConcentImg:false,
            concent_img:'',
            contentImg:[],
            natures:[
                {
                    num:'1',
                    value:'待审核',
                },
                {
                    num:'2',
                    value:'已通过',
                },
                {
                    num:'-2',
                    value:'已拒绝',
                },
                {
                    num:'3',
                    value:'已完成',
                },
                {
                    num:'-1',
                    value:'已撤回',
                },
            ],
            showCashInfo:false,
            member:'',
            community:'',
            invoice_account_name:'',
            invoice_bank_name:'',
            invoice_acount:'',
            extract_cost:'',
            status:'',
            remark:'',
            create_time:'',
            can_extract_cost:'',
            page:0,
            imgNum:0,
            showAfterImg:true,
            showBeforeImg:false,
        }
    },

    computed: { },

    watch: {
        route: {
            handler: function(val, old){

            },
            deep: true
        }
    },

    created(){

    },

    mounted(){
        this.loadMain();

        this.getData();

        this.seachCashList()
    },

    methods:{
        loadMain(){

        },

        getData(){

        },

        imgGoBefore(){
            this.showAfterImg = true
            this.imgNum = this.imgNum-1
            console.log(this.imgNum)
            //console.log(this.contentImg.length-1)
            if(this.imgNum  < 0){
                this.showBeforeImg = false
                return this.$message({
                    type:'warning',
                    message:'第一张图片',
                    duration:1000
                })
            }
            for(var i=0;i<this.contentImg.length;i++){
                this.concent_img = this.contentImg[this.imgNum]
            }
        },
        imgGoAfter(){
            this.showBeforeImg = true
            this.imgNum = this.imgNum+1
            if(this.imgNum  == (this.contentImg.length)){
                this.imgNum = this.contentImg.length
                this.showAfterImg = false
                return this.$message({
                    type:'warning',
                    message:'最后一张图片了',
                    duration:1000
                })
            }
            for(var i=0;i<this.contentImg.length;i++){
                this.concent_img = this.contentImg[this.imgNum]
            }
        },
        seachCashList(){
            this.$jssdk.property_lift.list({
                status:this.select.nature,
                start_time:this.select.startTime,
                end_time:this.select.endTime,
                is_export:'0',
                page:this.page,
            },(data) =>{
                this.meterList = data.data
                for(var i=0;i<this.meterList.length;i++){
                    
                }
                this.total = data.total
            },(err) =>{
                this.$message({
                    type:'warning',
                    message:err.msg,
                    duration:1000
                })
            })
        },
        downLoadList(){
            this.$jssdk.property_lift.list({
                status:this.select.nature,
                start_time:this.select.startTime,
                end_time:this.select.endTime,
                is_export:'1',
                page:this.page,
            },(data) =>{
                window.location.href = data.url
            },(err) =>{
                this.$message({
                    type:'warning',
                    message:err.msg,
                    duration:1000
                })
            })
        },
        returnSearch(){
            this.select.startTime = ''
            this.select.endTime = ''
            this.select.nature = ''
        },
        handleSizeChange(val) {},
        handleCurrentChange(val) {
            this.page = val
            this.$jssdk.property_lift.list({
                status:this.select.nature,
                start_time:this.select.startTime,
                end_time:this.select.endTime,
                is_export:'0',
                page:val,
                sort_by: this.prop,
                sort_to: this.order
            },(data) =>{
                this.meterList = data.data
                console.log(data)
            },(err) =>{
                return this.$message({
                    type:'warning',
                    message:err.msg,
                    duration:2000
                })
            })
        },
        removeCash(scope){
            this.$jssdk.lift.delete({
                id:scope.id
            },(res)=>{
                console.log(res)
                this.$message({
                    type:'success',
                    message:res,
                    duration:1000
                })
                return this.seachCashList()
            },(err)=>{
                this.$message({
                    type:'warning',
                    message:err.msg,
                    duration:1000
                })
            })
            console.log(scope.id)
        },
        cashInfo(scope){
            this.$jssdk.property_lift.detail({
                id:scope.id
            },(res) =>{
                this.showCashInfo = true
                this.member = res.member,
                this.community = res.community
                this.invoice_account_name = res.invoice_account_name
                this.invoice_bank_name = res.invoice_bank_name
                this.invoice_acount = res.invoice_acount
                this.extract_cost = res.extract_cost
                this.status = res.status
                this.remark = res.remark
                this.create_time = res.create_time
                this.can_extract_cost = res.can_extract_cost
            },(err)=>{
                this.$message({
                    type:'warning',
                    message:err.msg,
                    duration:1000
                })
            })
        },
        closeCashInfo(){
            this.showCashInfo = false
        },
        showAttachment(scope){
            this.showConcentImg = true
            var scope = scope.attachment
            var imgUrl = new Array()
            imgUrl = scope.split(',')
            console.log(imgUrl)
            this.contentImg = imgUrl
            this.concent_img = imgUrl[0]
        },
        closeAttachment(){
            this.showConcentImg = false
        }
    },
}
</script>

<style lang='less'>

</style>

<style lang='less' scoped>
    .showImg{
		width: 800px;
		margin: 0 auto;
		position: relative;
		padding: 20px;
		margin-top: 10%;
		border:2px solid #8fceff;
		border-radius: 10px;
		box-shadow: 5px 10px 10px rgba(51,51,51,.3);
	}
	.before{
		position: absolute;
		left:0 ;
		top: 40%;
		cursor: pointer;
		width: 30px;
	}
	.after{
		position: absolute;
		right:0 ;
		top: 40%;
		cursor: pointer;
		width: 30px;
	}
	.showImg img{
		width: 55%;
	}
	.cash_info{
		width: 600px;
		margin: 0 auto;
		margin-top: 10%;
		border:2px solid #8fceff;
		border-radius: 10px;
		box-shadow: 5px 10px 10px rgba(51,51,51,.3);
	}
	.cash_info ul{
		list-style: none;
		background-color: #fff;
		margin: 0;
		padding: 0;
		border-radius: 10px;
	}
	.cash_info ul li{
		border-bottom: 1px solid #ccc;
		overflow: hidden;
		height: 40px;
		line-height: 40px;
	}
	.cash_info ul li span{
		width: 200px;
		float: left;
		text-align: right;
		font-size: 14px;
	}
	.cash_info ul li strong{
		width: 390px;
		float: left;
		font-size: 14px;
		font-weight: normal;
		text-align: left;
	}
	.cash_info ul li button{
		width: 150px;
		height: 30px;
		outline: none;
		border: none;
		background-color: #20a0ff;
		color: white;
		border-radius: 10px;
		cursor: pointer;
	}
	.cash_info ul li:last-child{
		border: none;
		margin-top: 20px;
		text-align: center;
		
	}
</style>


// WEBPACK FOOTER //
// PropertyRecord.vue?480aae9d